import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ResponsiveTabs from 'components/ResponsiveTabs/ResponsiveTabs';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DataLabel from 'views/Cards/DataLabel';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';
import GrillaEffect from 'views/Grillas/GrillaEffect';
import GrillaTarifasAgrupada from 'views/Grillas/GrillaTarifasAgrupada';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

function FacturacionBatch() {

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/21`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const GenerarPdf = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/21`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      const doc = new jsPDF();
      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: 'left',
          valign: 'center',
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const defaultFecha = [
    { id: 'periodo_vto', value: dayjs().subtract(1, 'month').format('YYYY-MM'), col_ori: 'a.FactFec' }
  ];

  const [dataPdoConsumo, setdataPdoConsumo] = useState([]);
  const [dataPdoConsTarif, setdataPdoConsTarif] = useState([]);
  const [dataPdoConsCpt, setDataPdoConsCpt] = useState([]);
  const [dataPdoConsDetalle, setdataPdoConsDetalle] = useState([]);

  const [dataPdoVencimiento, setdataPdoVencimiento] = useState([]);
  const [dataPdoVencTarif, setdataPdoVencTarif] = useState([]);
  const [dataPdoVencCpt, setDataPdoVencCpt] = useState([]);
  const [dataPdoVencDetalle, setdataPdoVencDetalle] = useState([]);

  const [filterPdoConsumo, setfilterPdoConsumo] = useState([]);
  const [filterPdoVencimiento, setfilterPdoVencimiento] = useState([]);

  const [tab, setTab] = useState(0);
  const [tabCon, setTabCon] = useState(0);
  const [tabVen, setTabVen] = useState(0);

  // Vista de la solapa Tarifas: 'agrupada' (por grupo macro) o 'plana' (grilla clásica)
  const [vistaTarifas, setVistaTarifas] = useState('agrupada');
  const toggleVistaTarifas = (
    <ToggleButtonGroup
      value={vistaTarifas}
      exclusive
      size="small"
      onChange={(_, v) => { if (v) setVistaTarifas(v); }}
      sx={{ mb: 1 }}
    >
      <ToggleButton value="agrupada">Por grupo</ToggleButton>
      <ToggleButton value="plana">Detalle plano</ToggleButton>
    </ToggleButtonGroup>
  );

  const currentFilters = tab === 0 ? filterPdoConsumo : filterPdoVencimiento;

  // [CONSULTORIA] Códigos nuevos con filtro de consumo eléctrico (sin planes de pago)
  const dataLabelIds = {
    0: {
      totalFacturado: 80,   // <- 49 + filtro
      totalKwh: 81,         // <- 23 + filtro
      totalSuministros: 82  // <- 57 + filtro
    },
    1: {
      totalFacturado: 86,   // <- 55 + filtro
      totalKwh: 87,         // <- 56 + filtro
      totalSuministros: 82  // <- 57 + filtro
    }
  };

  const currentIds = dataLabelIds[tab];

  const [filters, setFilters] = useState([...defaultFecha]);

  const [filtersReady, setFiltersReady] = useState(true);
  const [filterUpdateCount, setFilterUpdateCount] = useState(0);

  const handleFiltersUpdate = (newFilters, updateFunc) => {
    setFiltersReady(false);
    updateFunc(newFilters);
    setFilterUpdateCount(prev => prev + 1);
    setTimeout(() => {
      setFiltersReady(true);
    }, 100);
  };

  const updateFiltersPdoConsumo = (newFilters) => handleFiltersUpdate(newFilters, setfilterPdoConsumo);
  const updateFiltersPdoVencimiento = (newFilters) => handleFiltersUpdate(newFilters, setfilterPdoVencimiento);

  const url = `${process.env.REACT_APP_API_URL}/querysextgrilla/`;

  const colPdoConsumo = {
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    cantidad: { caption: 'Cantidad', enableColumnFilter: false },
  };

  const colsPdoConsumoTarifas = {
    periodo_consumo: { caption: 'Periodo Consumo' },
    categoria: { caption: 'Tarifa' },
    importe: { caption: 'Importe', enableColumnFilter: false },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    cantidad: { caption: 'Cant. Comprobantes', enableColumnFilter: false },
  };

  const colPdoConsumoCpt = {
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    concepto: { caption: 'Concepto', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };

  const colPdoConsumoDetalle = {
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    fact_fecha: { caption: 'Fecha Cbte.', enableColumnFilter: true },
    sum_nro: { caption: 'Suministro', enableColumnFilter: true },
    fact_let: { caption: 'Letra Cbte.', enableColumnFilter: true },
    fact_nro: { caption: 'Nro. Cbte.', enableColumnFilter: true },
    fact_cli_nom: { caption: 'Cliente', enableColumnFilter: true },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
  };

  const colPdoVencimiento = {
    periodo_vencimiento: { caption: 'Pdo. Vto.', enableColumnFilter: true },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    cantidad: { caption: 'Cantidad', enableColumnFilter: false },
  };

  const colsPdoVencimientoTarifas = {
    periodo_vencimiento: { caption: 'Periodo Vto.' },
    categoria: { caption: 'Tarifa' },
    importe: { caption: 'Importe', enableColumnFilter: false },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    cantidad: { caption: 'Cant. Comprobantes', enableColumnFilter: false },
  };

  const colPdoVencimientoCpt = {
    periodo_vencimiento: { caption: 'Pdo. Vto', enableColumnFilter: true },
    concepto: { caption: 'Concepto', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };

  const colPdoVencimientoDetalle = {
    periodo_vencimiento: { caption: 'Pdo. Vto.', enableColumnFilter: true },
    fact_fecha: { caption: 'Fecha Cbte.', enableColumnFilter: true },
    sum_nro: { caption: 'Suministro', enableColumnFilter: true },
    fact_let: { caption: 'Letra Cbte.', enableColumnFilter: true },
    fact_nro: { caption: 'Nro. Cbte.', enableColumnFilter: true },
    fact_cli_nom: { caption: 'Cliente', enableColumnFilter: true },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
  };

  // const columnNames = { ... }
  const columnNames = {
    periodo_vencimiento: { caption: 'Pdo. Vto.', enableColumnFilter: true },
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    fecha_cbte: { caption: 'Fecha Cbte.', enableColumnFilter: true },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
  };

  const columnNames2 = {
    concepto: 'Concepto',
    importe: 'Importe',
    periodo_consumo: 'Pdo. Consumo',
    periodo_vto: 'Pdo. Vto.'
  };

  const columnNames3 = {
    periodo_consumo: { caption: 'Periodo Consumo' },
    categoria: { caption: 'Tarifa' },
    importe: { caption: 'Importe', enableColumnFilter: false },
    kw_hora: { caption: 'KW Hora', enableColumnFilter: false },
    cantidad: { caption: 'Cant. Comprobantes', enableColumnFilter: false },
  };

  const topToolbar = function (table) {
    return <Box>
      <DatePicker
        label="Desde"
        value={filters.find(i => i.id == 'periodo_vto').value}
        onChange={(fecha) => {
          let items = [...filters];
          const x = items.findIndex(i => i.id == 'periodo_vto');
          console.log(items[x]);
          let item = { ...items[x], value: [fecha, items[x].value[1]] };
          items[x] = item;
          table.table.setColumnFilters(items);
        }}
      />
      <DatePicker
        label="Hasta"
        value={filters.find(i => i.id == 'periodo_vto').value}
        onChange={(fecha) => {
          let items = [...filters];
          console.log('items aqui');
          const x = items.findIndex(i => i.id == 'fact_fecha');
          console.log(fecha);
          let item = { ...items[x], value: [items[x].value[0], fecha] };
          items[x] = item;
          table.table.setColumnFilters(items);
        }}
      />
    </Box>;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardBody>
          {/* KPI Cards */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={6}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={url + '?id=' + currentIds.totalFacturado}
                    filters={currentFilters}
                    columns={columnNames}
                    label={"TOTAL FACTURADO"}
                    filtersReady={filtersReady}
                    updateCount={filterUpdateCount}
                    explanationText={tab === 0 ? "Fact. x Cons. (12 meses)" : "Fact. x Vto. (desde hace 12 meses en adelante)"}
                  />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={url + '?id=' + currentIds.totalKwh}
                    filters={currentFilters}
                    columns={columnNames}
                    label={"TOTAL KWH"}
                    isMoney={false}
                    filtersReady={filtersReady}
                    updateCount={filterUpdateCount}
                    explanationText={tab === 0 ? "Fact. x Cons. (12 meses)" : "Fact. x Vto. (desde hace 12 meses en adelante)"}
                  />
                </CardBody>
              </Card>
            </Grid>
            {/* BOTONES EXPORTAR — pendiente activar
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody>
                  (botones futuros aquí)
                </CardBody>
              </Card>
            </Grid>
            */}
          </Grid>
          <Card sx={{ p: 2, my: 1 }}>
            <CardBody>
              <ResponsiveTabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                tabs={[
                  { label: 'Por periodo de Consumo' },
                  { label: 'Por periodo de Vencimiento' },
                ]}
              />

              {tab === 0 && (
                <Box pt={1}>
                  <ResponsiveTabs
                    value={tabCon}
                    onChange={(_, v) => setTabCon(v)}
                    tabs={[
                      { label: 'Periodo' },
                      { label: 'Tarifas' },
                      { label: 'Conceptos' },
                      { label: 'Detalle' },
                    ]}
                  />
                  {tabCon === 0 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataPdoConsumo} updateData={setdataPdoConsumo}
                          filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                          colsHeaders={colPdoConsumo}
                          idRemoto={83}
                          defaultSorting={[
                            { id: 'periodo_consumo', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                  {tabCon === 1 && (
                    <Box pt={1}>
                      {toggleVistaTarifas}
                      {vistaTarifas === 'agrupada' ? (
                        <GrillaTarifasAgrupada tipo="consumo" />
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                          <GrillaEffect
                            data={dataPdoConsTarif} updateData={setdataPdoConsTarif}
                            filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                            colsHeaders={colsPdoConsumoTarifas}
                            idRemoto={84}
                            defaultSorting={[
                              { id: 'periodo_consumo', desc: true },
                              { id: 'categoria', desc: false },
                            ]} />
                        </LocalizationProvider>
                      )}
                    </Box>
                  )}
                  {tabCon === 2 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataPdoConsCpt} updateData={setDataPdoConsCpt}
                          filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                          colsHeaders={colPdoConsumoCpt}
                          idRemoto={41}
                          defaultSorting={[
                            { id: 'periodo_consumo', desc: true },
                            { id: 'importe', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                  {tabCon === 3 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataPdoConsDetalle} updateData={setdataPdoConsDetalle}
                          filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                          colsHeaders={colPdoConsumoDetalle}
                          idRemoto={85}
                          defaultSorting={[
                            { id: 'fact_fecha', desc: true },
                            { id: 'importe_total', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                </Box>
              )}

              {tab === 1 && (
                <Box pt={1}>
                  <ResponsiveTabs
                    value={tabVen}
                    onChange={(_, v) => setTabVen(v)}
                    tabs={[
                      { label: 'Periodo' },
                      { label: 'Tarifas' },
                      { label: 'Conceptos' },
                      { label: 'Detalle' },
                    ]}
                  />
                  {tabVen === 0 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataPdoVencimiento} updateData={setdataPdoVencimiento}
                          filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                          colsHeaders={colPdoVencimiento}
                          idRemoto={88}
                          defaultSorting={[
                            { id: 'periodo_vencimiento', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                  {tabVen === 1 && (
                    <Box pt={1}>
                      {toggleVistaTarifas}
                      {vistaTarifas === 'agrupada' ? (
                        <GrillaTarifasAgrupada tipo="vencimiento" />
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                          <GrillaEffect
                            data={dataPdoVencTarif} updateData={setdataPdoVencTarif}
                            filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                            colsHeaders={colsPdoVencimientoTarifas}
                            idRemoto={89}
                            defaultSorting={[
                              { id: 'periodo_vencimiento', desc: true },
                              { id: 'categoria', desc: false },
                            ]} />
                        </LocalizationProvider>
                      )}
                    </Box>
                  )}
                  {tabVen === 2 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataPdoVencCpt} updateData={setDataPdoVencCpt}
                          filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                          colsHeaders={colPdoVencimientoCpt}
                          idRemoto={53}
                          defaultSorting={[
                            { id: 'periodo_vencimiento', desc: true },
                            { id: 'importe', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                  {tabVen === 3 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataPdoVencDetalle} updateData={setdataPdoVencDetalle}
                          filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                          colsHeaders={colPdoVencimientoDetalle}
                          idRemoto={90}
                          defaultSorting={[
                            { id: 'fact_fecha', desc: true },
                            { id: 'importe_total', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                </Box>
              )}
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Box>
  );
}

export default FacturacionBatch;
